import { FieldValues, RegisterOptions, useController } from 'react-hook-form';
import Upload, { ItemRender } from '@components/common/upload';
import Icon from '@components/common/assets';
import Text from '@components/common/text';
import { profileImageBeforeUpload } from '@components/common/upload/beforeUpload';
import { FontStyle } from '@domain/constant/fontStyle';
import Colors from '@domain/constant/colors';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

const researchUploadItemRender: ItemRender = (originNode, { fileName }, fileList, { download, remove }) => {
  return (
    <div className={cx('fileListArea')}>
      <div className={cx('fileListWrap')}>
        <a className={cx('fileName')} role="button" onClick={download}>
          {fileName}
        </a>
        <a className={cx('btnFileDelete')} role="button" onClick={remove}>
          <Icon name="deleteLight" width={20} height={20} />
        </a>
      </div>
    </div>
  );
};

interface Props extends HookFormProps {
  rules?:
    | Omit<RegisterOptions<FieldValues, string>, 'setValueAs' | 'disabled' | 'valueAsNumber' | 'valueAsDate'>
    | undefined;
}
const PassUpload = ({ prefixName, rules }: Props) => {
  const { field: fileField, fieldState } = useController({ name: prefixName, defaultValue: [], rules });
  const file = fileField.value[0];

  return (
    <div className={cx('uploadArea', { error: fieldState.invalid })}>
      {file ? (
        <div className={cx('uploadFile')}>
          <div className={cx('titleArea')}>
            <Text fontStyle={FontStyle.B3P_M}>{file?.fileName}</Text>
            <button onClick={() => fileField.onChange([])}>
              <Icon name="deleteLight" width={24} height={24} />
            </button>
          </div>

          <img className={cx('uploadImg')} src={file.fileUrl} alt={file.fileName} />
        </div>
      ) : (
        <Upload
          {...fileField}
          itemRender={researchUploadItemRender}
          accepts={['.jpg', '.png']}
          beforeUpload={profileImageBeforeUpload}
        >
          <div className={cx('upload')}>
            <div className={cx('icon')}>
              <Icon name="addLight" width={48} height={48} fill={Colors.C_COOL_GRAY_60} />
            </div>
            <Text fontStyle={FontStyle.B1P_M} color={Colors.C_COOL_GRAY_70} styles={{ marginTop: 16 }}>
              인증 사진 업로드
            </Text>
            <Text
              fontStyle={FontStyle.B3P_M}
              color={Colors.C_COOL_GRAY_60}
              styles={{ marginTop: 8, textAlign: 'center' }}
            >
              기업명, 이름 등 합격을 확인할 수 있는
              <br />
              이미지를 업로드해 주세요.
            </Text>
            <input {...fileField} className={cx('hidden')} />
          </div>
        </Upload>
      )}
    </div>
  );
};

export default PassUpload;
